import '../validatorMethods';

jQuery(($) => {
	$('.profileManagementForm')
		.each(
			(_, e) =>
				void $(e).on(
					'revalidate',
					() =>
						void $(e).validate({
							errorClass: 'message error',
							highlight(element, errorClass) {
								$(element).addClass(errorClass).removeClass('message');
							},
							rules: {
								Member_Email: {
									required: true,
									optionalEmail: true,
								},
								Member_Password_New: {
									minlength: 8,
								},
								Member_AddressPostcode: {
									postcode: true,
								},
								Member_Phone: {
									optionalPhone: true,
								},
								Member_SecondaryPhone: {
									optionalPhone: true,
								},
								Dealer_Email: {
									optionalEmail: true,
								},
								Dealer_PrimaryPhone: {
									optionalPhone: true,
								},
								Dealer_SecondaryPhone: {
									optionalPhone: true,
								},
								Dealer_Website: {
									optionalWebsite: true,
								},

								...(() => {
									// foreach contact field that has CanDelete false
									const rules: Record<string, any> = {};
									for (
										let i = 0, canDeleteField = $(e).find(`[name=Dealer_Contact_${i}_CanDelete]`);
										canDeleteField.length > 0;
										i++, canDeleteField = $(e).find(`[name=Dealer_Contact_${i}_CanDelete]`)
									) {
										const canDelete = canDeleteField.val();

										if (!canDelete) {
											Object.assign(rules, {
												[`Dealer_Contact_${i}_FirstName`]: {
													required: true,
												},
												[`Dealer_Contact_${i}_Surname`]: {
													required: true,
												},
												[`Dealer_Contact_${i}_Phone`]: {
													required: true,
													optionalPhone: true,
												},
											});
										}
									}
									return rules;
								})(),
							},
							messages: {
								Member_FirstName: {
									required: 'Please enter your first name',
								},
								Member_Surname: {
									required: 'Please enter your surname',
								},
								Member_Email: {
									required: 'Please enter your email address',
									email: 'Please enter a valid email address',
								},
								Member_Phone: {
									required: 'Please enter your phone number',
								},
								Member_AddressLine1: {
									required: 'Please enter your address',
								},
								Member_AddressCity: {
									required: 'Please enter your city',
								},
								Member_AddressPostcode: {
									required: 'Please enter your postcode',
								},
								Member_AddressState: {
									required: 'Please select your state',
								},
								Member_Password_New: {
									minlength: 'Please enter a password with at least 8 characters',
									required: 'Please enter a password',
								},

								Dealer_Title: {
									required: 'Please enter your business name',
								},
								Dealer_Email: {
									required: 'Please enter your email address',
									email: 'Please enter a valid email address',
								},
								Dealer_Phone: {
									required: 'Please enter your phone number',
								},
								...(() => {
									// foreach contact field that has CanDelete false
									const rules: Record<string, any> = {};
									for (
										let i = 0, canDeleteField = $(e).find(`[name=Dealer_Contact_${i}_CanDelete]`);
										canDeleteField.length > 0;
										i++, canDeleteField = $(e).find(`[name=Dealer_Contact_${i}_CanDelete]`)
									) {
										const canDelete = canDeleteField.val();

										if (!canDelete) {
											Object.assign(rules, {
												[`Dealer_Contact_${i}_FirstName`]: {
													required: 'Please enter a first name',
												},
												[`Dealer_Contact_${i}_Surname`]: {
													required: 'Please enter a surname',
												},
												[`Dealer_Contact_${i}_Phone`]: {
													required: 'Please enter a phone number',
												},
											});
										}
									}
									return rules;
								})(),
							},
							errorPlacement(error, element) {
								if (element.is('.reuploadField__file')) {
									error.insertAfter(element.parent());
								} else {
									error.insertAfter(element);
								}
							},
						})
				)
		)
		.trigger('revalidate');
});
